var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (description, i18n, title) {
buf.push("<div class=\"content-intro content-fill content-fit\"><div class=\"block-v-lg text-center content\"><div class=\"row\"><div class=\"col-sm-12 col-md-8 col-md-offset-2\"><h1 class=\"tight\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"text-lg block-v-lg\">" + (null == (jade_interp = description) ? "" : jade_interp) + "</div><div class=\"btn btn-solid play-game\">" + (jade.escape(null == (jade_interp = i18n("game.play-game")) ? "" : jade_interp)) + "</div></div></div></div></div>");}.call(this,"description" in locals_for_with?locals_for_with.description:typeof description!=="undefined"?description:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}